import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import gameApi from '../../../api/gameApi';
import userApi from '../../../api/userApi';
import HeaderParkManager from '../../../components/HeaderParkManager';
import WaitingForLandscape from '../../../components/WaitingForLandscape';
import {HandleCountDownTimerPlayer} from "../../../utils/TimerCountDown";
import {useStoreUser} from "../../../store";

ParkManagerWaitingHarvestors.propTypes = {};

function ParkManagerWaitingHarvestors(props) {
  const [isTimer, setIsTimer] = useState(false);
  const [countDown, setCountDown] = useState(null);
  const [timerEnd, setTimerEnd] = useState(null);

  const refMinutes = useRef();
  const refSeconds = useRef();

  const navigate = useNavigate();
  const [landscapeView, setLandscapeView] = useState([]);

  const [waiting, setWaiting] = useState(true);

  const [stateUser] = useStoreUser();
  const {qrCode} = stateUser;

  useEffect(() => {
    (async () => {
      try {
        // const qrCode = localStorage.getItem('qrCode');
        const response = await userApi.getCountDownTime(qrCode);

        const countdownTime = response?.countdown_for_player;
        let timeFormat = countdownTime.split(':');
        let convertTime = (+timeFormat[0]) * 60 +
          (+timeFormat[1]);

        setCountDown(convertTime);
        setTimerEnd(response.set_time_for_player_end_at);
        setIsTimer(true);
      } catch (e) {
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        // const qrCode = localStorage.getItem('qrCode');
        const response = await gameApi.getLandscapePlayer(qrCode);
        setLandscapeView(response?.landscape);
        setWaiting(!waiting);
      } catch (e) {
      }
    })();
  }, []);

  useEffect(() => {
    let displayMinutes = refMinutes.current;
    let displaySeconds = refSeconds.current;

    const dateNow = Math.floor(Date.now() / 1000);
    const timeLeft = timerEnd - dateNow;

    0 < countDown && setTimeout(() => {
      let minutes;
      let seconds;
      minutes = parseInt(countDown / 60, 10);
      seconds = parseInt(countDown % 60, 10);

      minutes = 10 > minutes ? '0' + minutes : minutes;
      seconds = 10 > seconds ? '0' + seconds : seconds;

      if (displayMinutes && displaySeconds) {
        displayMinutes.innerHTML = minutes;
        displaySeconds.innerHTML = seconds;
      }

      if (countDown > timeLeft) {
        setCountDown(timeLeft - 1);
      } else {
        setCountDown(countDown - 1);
      }
    }, 1000);

    if (0 === countDown) {
      if (displayMinutes && displaySeconds) {
        displayMinutes.innerHTML = '00';
        displaySeconds.innerHTML = '00';
      }
      navigate('/park-manager-waiting-decision', {replace: true});
    }
  }, [countDown]);

  const onFocusPM = async () => {
    const qrCode = localStorage.getItem('qrCode');
    const timeCountDown = await HandleCountDownTimerPlayer(qrCode);
    setCountDown(timeCountDown?.time_current);
    setTimerEnd(timeCountDown?.time_end);
  };

  useEffect(() => {
    window.addEventListener("focus", onFocusPM);
    return () => {
      window.removeEventListener("focus", onFocusPM);
    };
  }, []);

  return (
    <div className={'min-vh'}>
      <div className={'container-sm'}>
        <HeaderParkManager title={"Let's wait for<br/> the harvesters"}/>


        <div className={'game-content'}>
          {waiting && <WaitingForLandscape/>}

          {!waiting &&
          <div className={'game-board small'}>
            <div className={'game-title-row'}>
              <div>A</div>
              <div>B</div>
              <div>C</div>
              <div>D</div>
              <div>E</div>
            </div>
            <div className={'game-title-col'}>
              <div>1</div>
              <div>2</div>
              <div>3</div>
              <div>4</div>
            </div>
            <div className={'game-list'}>
              {Object.entries(landscapeView).map((value, index) => (
                <div key={index}
                     className={`game-item 
                      ${value[1]?.is_protected === 'true' ? 'active' : ''}`}
                     style={{backgroundColor: value[1].color}}>
                  {0 < value[1].animal_qty &&
                  <p className={'animal-icon'}>{[
                    ...Array(value[1].animal_qty)].map(
                    (currentValue, i) => (
                      <span key={i}>&nbsp;</span>))}</p>}
                </div>
              ))}
            </div>
          </div>}

          {isTimer &&
          <div className={'time-left'}>
            <h3 className={'center'}>Time Left</h3>
            <div id={'countDown'}
                 className={'count-down'}>
              <span ref={refMinutes}>--</span>
              <span className={'split'}>:</span>
              <span ref={refSeconds}>--</span>
            </div>
          </div>}
        </div>
      </div>
    </div>
  );
}

export default ParkManagerWaitingHarvestors;
